import React, { FC, useEffect, useState } from 'react'

import { htmlCleanup } from '@sportworld/js-sdk/src/utils/utils'

import { Loader } from '@/components/Loader'
import { PageFallback } from '@/components/PageFallback/PageFallback'
import { SettingsHeader } from '@/components/SettingsHeader'
import { scrollBarOffset } from '@/constants/common'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import { HTMLWrapper, TextElem } from './styles'
import { SettingsContainer } from '../styles'

import 'element-scroll-polyfill'

type StaticHTMLPageProps = {
  focusId: string
  titleTranslationKey: string
  onPageLoad: () => Promise<string | undefined>
}
export const StaticHTMLPage: FC<StaticHTMLPageProps> = ({
  focusId,
  titleTranslationKey,
  onPageLoad,
}) => {
  const { t } = useCommonTranslation()

  const [html, setHtml] = useState('')
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    void loadPage()
  }, [])

  const loadPage = async () => {
    setLoading(true)
    setError(false)

    try {
      const res = await onPageLoad()
      if (res) {
        setHtml(htmlCleanup(res))
      }
    } catch (err) {
      console.error(`[StaticHTMLPage] failed to load page / ${onPageLoad.name}`)
      setError(true)
    } finally {
      setLoading(false)
    }
  }

  const scrollDown = (e: LRUDEvent) => {
    const container = e.targetNode.elRef.current
    container?.scrollTo(0, container.scrollTop + scrollBarOffset)
  }

  const scrollUp = (e: LRUDEvent) => {
    const container = e.targetNode.elRef.current
    container?.scrollTo(0, container.scrollTop - scrollBarOffset)
  }

  return (
    <SettingsContainer focusId={focusId}>
      {loading && <Loader />}
      {error && <PageFallback reloadHandler={loadPage} />}
      {!loading && !error && (
        <>
          <SettingsHeader title={t(titleTranslationKey)} />
          <TextElem
            elementType="section"
            focusId="static-html-text-elem"
            onDown={scrollDown}
            onUp={scrollUp}
          >
            {html && (
              <HTMLWrapper
                dangerouslySetInnerHTML={{
                  __html: html,
                }}
              />
            )}
          </TextElem>
        </>
      )}
    </SettingsContainer>
  )
}
